import React from "react";
import {dayjs} from "hooks/dayjsSetup";
import { ImUnlocked} from "react-icons/im";
import {useTekstClient} from "hooks/useTekstClient";
import ContentListItemRight from "./Components/ContentListItemRight";
import {useFormTitle} from "../../../../hooks/useFormTitle";
import LocalizedLinkClient from "components/LocalizedLink/LocalizedLinkClient";
import useGebruiker from "hooks/useGebruiker";

// Breed genoeg voor het langste label in alle talen (o.a. "Neuestes Update:"), zodat de waarden uitgelijnd blijven
const labelBreedte = 'w-[115px] shrink-0 whitespace-nowrap'

const ContentListItem = ({
                             weergaveCompact,
                             searchParams,
                             handleOpenInNieuwVenter,
                             handleBewerken,
                             item,
                             handleBookmark
                         }) => {
    const {inhoud, kenmerk} = searchParams
    const {tekst} = useTekstClient()
    const {ingelogdeGebruiker} = useGebruiker()
    const {formTitle} = useFormTitle()

    const isMkger = !!ingelogdeGebruiker?.groep?.mkger;

    // An item without published content cannot be rendered; skip it instead of crashing the whole list.
    if (!item.content_gepubliceerd) return null;

    const rerankPct = typeof item._rerank_score === 'number'
        ? Math.round(item._rerank_score * 100)
        : null;

    // _found_by: "semantic" | "fulltext" | "both" — set by the Python hybrid pipeline
    const foundBy = item._found_by;
    const foundByShort = foundBy === 'both' ? 'both' : foundBy === 'fulltext' ? 'ft' : 'sem';
    const foundByTitle = foundBy === 'both'
        ? 'semantic + fulltext'
        : foundBy === 'fulltext' ? 'fulltext' : 'semantic';

    return <li key={item.id} className={`border-b border-inherit ${weergaveCompact ? 'my-0' : 'my-3'}`}>

        {/*Header*/}
        <div className={`flex`}>
            {/*Titel*/}
            <h2 className={`!text-2xl  ${weergaveCompact ? 'pb-0' : 'pb-2'} mr-2`}>
                {isMkger && foundBy && (
                    <span
                        title={`${foundByTitle}${rerankPct !== null ? ` — rerank: ${rerankPct}%` : ''}`}
                        className="inline-flex items-center gap-1 align-middle mr-2 h-[20px] px-1.5 text-[11px] font-mono font-semibold rounded-sm bg-slate-100 text-slate-500 border border-slate-300"
                    >
                        <span>{foundByShort}</span>
                        {rerankPct !== null && <span>{rerankPct}%</span>}
                    </span>
                )}
                {item.autorisatie !== 0 && <ImUnlocked className={`inline-block mt-[-3px] mr-2`}/>}
                <LocalizedLinkClient
                    href={`/mijn-mkg/support/kenniscentrum/id/${item.id}/${formTitle(item.content_gepubliceerd.titel)}`}
                    className={`#`}>{item.content_gepubliceerd.titel}</LocalizedLinkClient>
            </h2>

            {/*Menu Right*/}
            <div className={`ml-auto pt-1`}>
                <ContentListItemRight
                    item={item}
                    handleBookmark={handleBookmark}
                    handleOpenInNieuwVenter={handleOpenInNieuwVenter}
                    handleBewerken={handleBewerken}
                />
            </div>
        </div>

        <div className={`flex items-start`}>
            {/*Typen & Categorie & Versie*/}
            <div className={`text-sm`}>

                {/*Typen*/}
                <div className={`flex items-center`}>
                    <div
                        className={`text-kleur-grijs-cyan mr-2 ${labelBreedte}`}>{tekst('pagina:support:kenniscentrum:lijst-item:Type')}</div>
                    <LocalizedLinkClient
                        href={`/mijn-mkg/support/kenniscentrum?typen=${item.wiki_type.id}`}>{item.wiki_type.naam}</LocalizedLinkClient>
                </div>

                {/*Categorie*/}
                {item.categorieen.length > 0 && <div className={`flex items-start`}>
                    <div
                        className={`text-kleur-grijs-cyan mr-2 ${labelBreedte}`}>{tekst('pagina:support:kenniscentrum:lijst-item:Categorie')}</div>
                    <div className={`flex flex-wrap`}>
                        {item.categorieen.length > 0 && item.categorieen?.map(categorie => {
                            return <LocalizedLinkClient key={item.id + categorie.id} className={`mr-2`}
                                         href={`/mijn-mkg/support/kenniscentrum?cat=${categorie.id}`}>
                                {categorie.path}
                            </LocalizedLinkClient>
                        })}
                    </div>
                </div>}

                {/*Laatste update*/}
                {item.content_gepubliceerd.aanmaakdatum && <div className={`flex items-start`}>
                    <div
                        className={`text-kleur-grijs-cyan mr-2 ${labelBreedte}`}>{tekst('pagina:support:storingen:storing:laatste update')}</div>
                    <div>{dayjs(item.content_gepubliceerd.aanmaakdatum).format('YYYY-MM-DD')}</div>
                </div>}


                {/*if Releasenotes*/}
                {inhoud && <div className={`flex items-center`}>
                    <div
                        className={`text-kleur-grijs-cyan mr-2 ${labelBreedte}`}>{tekst('pagina:support:kenniscentrum:lijst-item:Versies')}</div>

                    {item.versies.length > 0 && item.versies.map((v, i) => {
                        const productLabel = item.producten.length > 0
                          && item.producten.find(x => x.id === v.pivot.product_id)
                        return <span key={item.id + v.nr + i}
                                     className={`text-white bg-kleur-grijs-cyan rounded-sm font-bold text-[10px] mr-1 px-1 h-[15px] leading-[15px]`}>{productLabel
                            ? `${productLabel.naam} | `
                            : `${item.producten.length > 0
                                ? item.producten.map(x => x.naam).join(' | ')
                                : ''} | `}{v.nr}
                                        </span>
                    })}
                </div>
                }

                {/*Kenmerk & releasenote*/}
                {inhoud && kenmerk && <div className={`flex items-center`}>
                    <div className={`text-kleur-grijs-cyan mr-2 ${labelBreedte}`}>Kenmerk:</div>
                    <div
                        className={`text-white bg-kleur-grijs-cyan rounded-sm font-bold text-[10px] mr-1 px-1 h-[15px] leading-[15px]`}>{kenmerk}</div>
                </div>
                }
            </div>

            <div className={`ml-auto`}>
                {item.wiki_type.id !== 3 && <div className={`flex item-center`}>
                    {item.producten.length > 0 && item.producten.map(v => <div key={item.id + v.naam}
                                                                               className={`text-white bg-kleur-donker-blauw rounded-sm font-bold text-[10px] mr-1 px-1 h-[15px] leading-[15px]`}>{v.naam}</div>)}
                </div>
                }
            </div>

        </div>


        <p className={`overflow-hidden text-ellipsis line-clamp-3 mt-2 ${weergaveCompact ? 'mb-2' : 'mb-3'}`}>
            {!weergaveCompact && item.content_gepubliceerd.intro}
        </p>
    </li>
}
export default ContentListItem;
